<template>
  <b-row>
    <b-col sm="12">
        <div v-if="pieOptions.day === null" class="text-center" style="font-size: 1em; padding: 100px 0px 100px;">
          <b-badge>There's no statistics data</b-badge>
        </div>
        <vue-highcharts :options="pieOptions.day"></vue-highcharts>
    </b-col>
  </b-row>
</template>

<script>
import VueHighcharts from 'vue2-highcharts'
import Highcharts from 'highcharts'
// import * as initConfigChart from '@/views/components/charts/HighchartInit'

export default {
  name: 'panicPieChart',
  components: {
    VueHighcharts
  },
  data () {
    return {
      apiPieStatsVisitor: window.AppConfig.apiUrl + 'visitorstats',
      apiUrlStatus: window.AppConfig.apiUrl + 'visitor-status',
      color: {
        'Out Site': {
          'color': '#6c757d'
        },
        'At Site': {
          'color': '#3f82b6'
        }
      },
      pieOptions: {
        day: null,
        week: null,
        month: null
      },
      visitorStatusList: []
    }
  },
  mounted () {
    this.getVisitorStats('day')
    // this.doAutoRefresh()
  },
  beforeDestroy () {
    clearInterval(this.refVisitorPie)
  },
  methods: {
    getVisitorStats (period) {
      let dataChart = [
        {
          name: 'Out Site',
          selected: false,
          sliced: false,
          y: 2
        },
        {
          name: 'At Site',
          selected: false,
          sliced: false,
          y: 10
        }
      ]
      let opt = {
        chart: {
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          height: 300
        },
        title: {
          text: ''
        },
        series: [{
          name: 'data',
          data: []
        }],
        colors: [],
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y}</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 10,
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
              distance: -30,
              style: {
                color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
              }
            },
            size: '80%'
          }
        },
        noData: {
          attr: 'no Item display',
          position: {
            align: 'center',
            verticalAlign: 'middle',
            x: 0,
            y: 0
          }
        },
        credits: {
          enabled: false
        }
      }
      opt.series = [{
        name: 'data',
        data: dataChart
      }]
      opt.colors = [this.color['Out Site'].color, this.color['At Site'].color]
      let self = this
      opt.plotOptions.pie.point = {
        events: {
          click: function (e) {
            self.redirectToPage(this.name)
            return false
          }
        }
      }
      this.pieOptions[period] = opt
    },

    redirectToPage () {
      this.$router.push({path: '/visited-sites'})
    },

    doAutoRefresh () {
      this.refVisitorPie = setInterval(() => {
        this.getVisitorStats('day')
      }, window.AppConfig.IntervalRefreshDataDashboard)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/index/panicPieChart.vue